import { useContext } from 'react'

import { DarkModeContext } from '~/shared/components/DarkMode/context.ts'

export const useDarkMode = () => {
  const context = useContext(DarkModeContext)
  if (context === undefined) {
    throw new Error('useDarkMode must be used within a ModeProvider')
  }
  return context
}